.card {
  transition: opacity 0.25s ease-in-out 0.25s;
  height: 100%;
}

.imageNotLoaded { opacity: 0; }

.imageLoaded {
  opacity: 1;
}

.shell {
  aspect-ratio: 159/269;
  cursor: pointer;
}

.content {
  flex: 1 1 auto;
}

.reviewCount {
  margin-left: 2px;
}

/* Hide Review Count in the mid range */
@media all and (--reefer-media-desktop-sm-min) and (--reefer-media-desktop-md-max) {
  .reviewCount {
    display: none;
  }
}

@media all and (--reefer-media-desktop-md-min) {
  .shell {
    border-radius: var(--border-radius-lg);
  }

  .content {
    gap: 8px;
    padding: 16px;
  }
}

/* The compact row. */
@media all and (--reefer-media-desktop-sm-max) {
  .card {
    height: auto;
    width: 100%;
    min-width: 220px;
  }

  .shell {
    flex-direction: row;
    align-items: center;
    aspect-ratio: auto;
  }

  .imageSlot {
    width: 72px;
    height: 72px;
    flex-shrink: 0;
  }

  .content {
    justify-content: center;
    padding: 0 8px;
  }

  .lineage {
    display: none;
  }

  .rating {
    margin-left: 0;
  }
}
